/* Generated by ts-generator ver. 0.0.8 */
/* tslint:disable */

import { Contract, ContractFactory, Signer } from "ethers";
import { Provider } from "ethers/providers";
import { UnsignedTransaction } from "ethers/utils/transaction";
import { BigNumberish } from "ethers/utils";

import { GolemNetworkToken } from "./GolemNetworkToken";

export class GolemNetworkTokenFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _golemFactory: string,
    _migrationMaster: string,
    _fundingStartBlock: BigNumberish,
    _fundingEndBlock: BigNumberish
  ): Promise<GolemNetworkToken> {
    return super.deploy(
      _golemFactory,
      _migrationMaster,
      _fundingStartBlock,
      _fundingEndBlock
    ) as Promise<GolemNetworkToken>;
  }
  getDeployTransaction(
    _golemFactory: string,
    _migrationMaster: string,
    _fundingStartBlock: BigNumberish,
    _fundingEndBlock: BigNumberish
  ): UnsignedTransaction {
    return super.getDeployTransaction(
      _golemFactory,
      _migrationMaster,
      _fundingStartBlock,
      _fundingEndBlock
    );
  }
  attach(address: string): GolemNetworkToken {
    return super.attach(address) as GolemNetworkToken;
  }
  connect(signer: Signer): GolemNetworkTokenFactory {
    return super.connect(signer) as GolemNetworkTokenFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GolemNetworkToken {
    return new Contract(address, _abi, signerOrProvider) as GolemNetworkToken;
  }
}

const _abi = [
  {
    constant: true,
    inputs: [],
    name: "name",
    outputs: [
      {
        name: "",
        type: "string"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "golemFactory",
    outputs: [
      {
        name: "",
        type: "address"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "_master",
        type: "address"
      }
    ],
    name: "setMigrationMaster",
    outputs: [],
    payable: false,
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [
      {
        name: "",
        type: "uint8"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "_value",
        type: "uint256"
      }
    ],
    name: "migrate",
    outputs: [],
    payable: false,
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "finalize",
    outputs: [],
    payable: false,
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "refund",
    outputs: [],
    payable: false,
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "migrationMaster",
    outputs: [
      {
        name: "",
        type: "address"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "tokenCreationCap",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        name: "_owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "_agent",
        type: "address"
      }
    ],
    name: "setMigrationAgent",
    outputs: [],
    payable: false,
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "migrationAgent",
    outputs: [
      {
        name: "",
        type: "address"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "fundingEndBlock",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "totalMigrated",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "symbol",
    outputs: [
      {
        name: "",
        type: "string"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "_to",
        type: "address"
      },
      {
        name: "_value",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "tokenCreationMin",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "funding",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "tokenCreationRate",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "fundingStartBlock",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: false,
    inputs: [],
    name: "create",
    outputs: [],
    payable: true,
    type: "function"
  },
  {
    inputs: [
      {
        name: "_golemFactory",
        type: "address"
      },
      {
        name: "_migrationMaster",
        type: "address"
      },
      {
        name: "_fundingStartBlock",
        type: "uint256"
      },
      {
        name: "_fundingEndBlock",
        type: "uint256"
      }
    ],
    payable: false,
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: "_from",
        type: "address"
      },
      {
        indexed: true,
        name: "_to",
        type: "address"
      },
      {
        indexed: false,
        name: "_value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: "_from",
        type: "address"
      },
      {
        indexed: true,
        name: "_to",
        type: "address"
      },
      {
        indexed: false,
        name: "_value",
        type: "uint256"
      }
    ],
    name: "Migrate",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        name: "_from",
        type: "address"
      },
      {
        indexed: false,
        name: "_value",
        type: "uint256"
      }
    ],
    name: "Refund",
    type: "event"
  }
];

const _bytecode =
  "0x60606040526001600260006101000a81548160ff021916908315150217905550341561002a57600080fd5b604051608080612074833981016040528080519060200190919080519060200190919080519060200190919080519060200190919050505b60008473ffffffffffffffffffffffffffffffffffffffff16141561008657600080fd5b60008373ffffffffffffffffffffffffffffffffffffffff1614156100aa57600080fd5b43821115156100b857600080fd5b81811115156100c657600080fd5b836100cf6101f5565b808273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001915050604051809103906000f080151561011b57600080fd5b600460006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555082600360006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555083600260016101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555081600081905550806001819055505b50505050610205565b604051610bdb8061149983390190565b611285806102146000396000f30060606040523615610126576000357c0100000000000000000000000000000000000000000000000000000000900463ffffffff16806306fdde031461012b57806316222950146101ba57806318160ddd1461020f57806326316e5814610238578063313ce56714610271578063454b0608146102a05780634bb278f3146102c3578063590e1ae3146102d8578063676d2e62146102ed5780636f7920fd1461034257806370a082311461036b57806375e2ff65146103b85780638328dbcd146103f157806391b43d131461044657806395a0f5eb1461046f57806395d89b4114610498578063a9059cbb14610527578063c039daf614610581578063cb4c86b7146105aa578063cf8d652c146105d7578063d648a64714610600578063efc81a8c14610629575b600080fd5b341561013657600080fd5b61013e610633565b6040518080602001828103825283818151815260200191508051906020019080838360005b8381101561017f5780820151818401525b602081019050610163565b50505050905090810190601f1680156101ac5780820380516001836020036101000a031916815260200191505b509250505060405180910390f35b34156101c557600080fd5b6101cd61066c565b604051808273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200191505060405180910390f35b341561021a57600080fd5b610222610692565b6040518082815260200191505060405180910390f35b341561024357600080fd5b61026f600480803573ffffffffffffffffffffffffffffffffffffffff1690602001909190505061069d565b005b341561027c57600080fd5b610284610762565b604051808260ff1660ff16815260200191505060405180910390f35b34156102ab57600080fd5b6102c16004808035906020019091905050610767565b005b34156102ce57600080fd5b6102d66109f1565b005b34156102e357600080fd5b6102eb610bf2565b005b34156102f857600080fd5b610300610d86565b604051808273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200191505060405180910390f35b341561034d57600080fd5b610355610dac565b6040518082815260200191505060405180910390f35b341561037657600080fd5b6103a2600480803573ffffffffffffffffffffffffffffffffffffffff16906020019091905050610dbc565b6040518082815260200191505060405180910390f35b34156103c357600080fd5b6103ef600480803573ffffffffffffffffffffffffffffffffffffffff16906020019091905050610e06565b005b34156103fc57600080fd5b610404610f08565b604051808273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200191505060405180910390f35b341561045157600080fd5b610459610f2e565b6040518082815260200191505060405180910390f35b341561047a57600080fd5b610482610f34565b6040518082815260200191505060405180910390f35b34156104a357600080fd5b6104ab610f3a565b6040518080602001828103825283818151815260200191508051906020019080838360005b838110156104ec5780820151818401525b6020810190506104d0565b50505050905090810190601f1680156105195780820380516001836020036101000a031916815260200191505b509250505060405180910390f35b341561053257600080fd5b610567600480803573ffffffffffffffffffffffffffffffffffffffff16906020019091908035906020019091905050610f73565b604051808215151515815260200191505060405180910390f35b341561058c57600080fd5b6105946110f7565b6040518082815260200191505060405180910390f35b34156105b557600080fd5b6105bd611106565b604051808215151515815260200191505060405180910390f35b34156105e257600080fd5b6105ea611119565b6040518082815260200191505060405180910390f35b341561060b57600080fd5b610613611122565b6040518082815260200191505060405180910390f35b610631611128565b005b6040805190810160405280601381526020017f476f6c656d204e6574776f726b20546f6b656e0000000000000000000000000081525081565b600260019054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b600060055490505b90565b600360009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff161415156106f957600080fd5b60008173ffffffffffffffffffffffffffffffffffffffff16141561071d57600080fd5b80600360006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055505b50565b601281565b600260009054906101000a900460ff161561078157600080fd5b6000600760009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1614156107c757600080fd5b60008114156107d557600080fd5b600660003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000205481111561082157600080fd5b80600660003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600082825403925050819055508060056000828254039250508190555080600860008282540192505081905550600760009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16637a3130e333836040518363ffffffff167c0100000000000000000000000000000000000000000000000000000000028152600401808373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200182815260200192505050600060405180830381600087803b151561095257600080fd5b6102c65a03f1151561096357600080fd5b505050600760009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff167f18df02dcc52b9c494f391df09661519c0069bd8540141946280399408205ca1a836040518082815260200191505060405180910390a35b50565b600080600260009054906101000a900460ff161515610a0f57600080fd5b60015443111580610a2c57506a7c13bc4b2c133c56000000600554105b8015610a4557506b02a649c112686927b4000000600554105b15610a4f57600080fd5b6000600260006101000a81548160ff02191690831515021790555060129150816064038260055402811515610a8057fe5b049050806005600082825401925050819055508060066000600460009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008282540192505081905550600460009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1660007fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef836040518082815260200191505060405180910390a3600260019054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff166108fc3073ffffffffffffffffffffffffffffffffffffffff16319081150290604051600060405180830381858888f193505050501515610bed57600080fd5b5b5050565b600080600260009054906101000a900460ff161515610c1057600080fd5b60015443111515610c2057600080fd5b6a7c13bc4b2c133c56000000600554101515610c3b57600080fd5b600660003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000205491506000821415610c8b57600080fd5b6000600660003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002081905550816005600082825403925050819055506402540be40082811515610cf057fe5b0490503373ffffffffffffffffffffffffffffffffffffffff167fbb28353e4598c3b9199101a66e0989549b659a59a54d2c27fbb183f1932c8e6d826040518082815260200191505060405180910390a23373ffffffffffffffffffffffffffffffffffffffff166108fc829081150290604051600060405180830381858888f193505050501515610d8157600080fd5b5b5050565b600360009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b6b02a649c112686927b400000081565b6000600660008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000205490505b919050565b600260009054906101000a900460ff1615610e2057600080fd5b6000600760009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16141515610e6757600080fd5b600360009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff16141515610ec357600080fd5b80600760006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055505b50565b600760009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b60015481565b60085481565b6040805190810160405280600381526020017f474e54000000000000000000000000000000000000000000000000000000000081525081565b600080600260009054906101000a900460ff1615610f9057600080fd5b600660003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020549050828110158015610fe25750600083115b156110eb57828103905080600660003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000208190555082600660008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600082825401925050819055508373ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef856040518082815260200191505060405180910390a3600191506110f0565b600091505b5092915050565b6a7c13bc4b2c133c5600000081565b600260009054906101000a900460ff1681565b6402540be40081565b60005481565b6000600260009054906101000a900460ff16151561114557600080fd5b60005443101561115457600080fd5b60015443111561116357600080fd5b600034141561117157600080fd5b6402540be4006005546b02a649c112686927b40000000381151561119157fe5b0434111561119e57600080fd5b6402540be400340290508060056000828254019250508190555080600660003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600082825401925050819055503373ffffffffffffffffffffffffffffffffffffffff1660007fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef836040518082815260200191505060405180910390a35b505600a165627a7a72305820139c60e2336a94b411864d1d7086a8e0d3d2421ca92a133fc6cb7d565a3a78a5002960606040526000600355341561001457600080fd5b604051602080610bdb833981016040528080519060200190919050505b33600160006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555062ed4e004201600281905550614e206000808373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020819055506109c4600080739d3f257827b17161a098d380822fa2614ff540c873ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020819055506102da60008073d7406e50b73972fa4aa533a881af68b623ba3f6673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020819055506102da60008073d15356d05a7990de7ec94304b0fd538e550c09c073ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020819055506102da600080733971d17b62b825b151760e2451f818bfb64489a773ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020819055506102da6000807395e337d09f1bc67681b1cab7ed1125ea2bae5ca873ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020819055506102da6000807225c58db686b8cece05cb8c50c1858b63aa396e73ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000208190555061027660008073b127fc62de6ca30aac9d551591daeddebb2efd7a73ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020819055506102766000807321af2e2c240a71e9fb84e90d71c2b2adde0d0e8173ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000208190555061027660008073682aa1c3b3e102acb9c97b861d595f9fbff0f1b873ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002081905550610276600080736edd429c77803606cbd6bb501cc701a6cad6be0173ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002081905550610136600080735e455624372fe11b39464e93d41d1f6578c3d9f673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002081905550608a60008073b7c7ead515ca275d53e30b39d8ebedb3f19da24473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002081905550608760008073d513b1c3fe31f3fe0b1e42aa8f55e903f19f173073ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000208190555060646000807370cac7f8e404eefce6526823452e428b5ab09b0073ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002081905550606460008073e0d5861e7be0fac6c85ecde6e8bf76b046a9614973ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000208190555060646000807317488694d2fee4377ec718836bb9d4910e81d9cf73ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002081905550606460008073b481372086dec3ca2fccd3eb2f462c9c893ef3c573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002081905550604660008073fb6d91e69cd7990651f26a3aa9f8d5a89159fc9273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002081905550604660008073e2abdae2980a1447f445cb962f9c0bef1b63ee1373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002081905550604660008073729a5c0232712caaf365fdd03c39cb361bd41b1c73ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000208190555060466000807312fbd8fef4903f62e30dd79ac7f439f573e0269773ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002081905550602a60008073657013005e5cfaf76f75d03b465ce085d402469a73ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002081905550601960008073d0af9f75ea618163944585bf56aca98204d0ab6673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020819055505b505b610314806108c76000396000f30060606040526000357c0100000000000000000000000000000000000000000000000000000000900463ffffffff168063a69df4b51461003e575b600080fd5b341561004957600080fd5b610051610053565b005b60008060025442101561006557600080fd5b6000600354141561015757600160009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff166370a08231306000604051602001526040518263ffffffff167c0100000000000000000000000000000000000000000000000000000000028152600401808273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001915050602060405180830381600087803b151561013557600080fd5b6102c65a03f1151561014657600080fd5b505050604051805190506003819055505b6000803373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002054915060008060003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000208190555061753082600354028115156101ed57fe5b049050600160009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663a9059cbb33836000604051602001526040518363ffffffff167c0100000000000000000000000000000000000000000000000000000000028152600401808373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200182815260200192505050602060405180830381600087803b15156102bd57600080fd5b6102c65a03f115156102ce57600080fd5b5050506040518051905015156102e357600080fd5b5b50505600a165627a7a72305820238340307f30e296c9b92ccc703d84831e7a706756102cfc070acabfa3c05f670029";
